import { toggleTheme, useIsDark } from "./hooks"
import { MoonIcon, SunIcon } from "./icons"

/** Light and dark switch; the icon shows the theme it switches to. */
export function ThemeButton() {
  const dark = useIsDark()
  return (
    <button className="ib themebtn" type="button" aria-label={dark ? "Switch to light theme" : "Switch to dark theme"} onClick={toggleTheme}>
      {dark ? <SunIcon /> : <MoonIcon />}
    </button>
  )
}
